/**
 * The light-section switch (app/styles/surfaces.css). A page lists the ids of the sections
 * that sit on the light "plan sheet" surface, and `surfaceFor(list)` gives it a function
 * for each section's data-surface attribute: "light" if listed, otherwise undefined (no
 * attribute, so the section stays dark). Empty a page's list to put it back on all dark.
 */
export const surfaceFor = (lightSections) => (id) =>
  lightSections.includes(id) ? "light" : undefined;
